// Module
var code = `<div class="heatmap-panel">
    {{#if heatmapListItems.length > 1}}
        <div class="heatmap-panel-header">
            <div class="heatmap-panel-header-items-container">
                {{#each heatmapHeaderListItems: i}}
                    <div class="heatmap-panel-header-item{{#if heatmapHeaderListItems[i] === selectedListItem}} _selected{{/if}}" on-click="['onListItemClicked', heatmapHeaderListItems[i].id]">
                        <div class="heatmap-panel-header-item-text">
                            {{heatmapHeaderListItems[i].name}}
                        </div>
                        <div class="heatmap-panel-header-item-separator"></div>
                    </div>
                {{/each}}
            </div>
            {{#if heatmapContextMenuListItems.length > 0}}
                <terceraButton terceraButtonStyle="js-more-button" name="viewMoreHorizontal" SVG="true" on-btnClick="onMoreButtonClicked"/>
            {{/if}}
        </div>
    {{/if}}
    <div class="heatmap-panel-body">
        <heatmapRactive/>
    </div>
    <div class="heatmap-panel-footer">
        <heatmapSymbolInfo heatmapData="{{hoveredHeatmapData}}"/>
        {{#if isShowHeatmapFilter}}
            <heatmapFilter foregroundColor="{{filterForegroundColor}}" intervals="{{intervals}}" scaleMultiplier="{{scaleMultiplier}}" on-scaleFilterChanged="scaleFilterChanged" on-scaleMultiplierChanged="scaleMultiplierChanged"/>
        {{/if}}
    </div>
</div>`;
// Exports
export default code;